// extracted by mini-css-extract-plugin
module.exports = {"root":"PageBanner_root__pjOn_","imageWrapper":"PageBanner_imageWrapper__Zw2T_","image":"PageBanner_image__L9sAZ","title":"PageBanner_title__7B_mN"};